// @flow
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { fetchPurchaseHistory } from '../../actions';
import Form from '../../ui/components/Forms/History';

type Props = {
    auth: {
        purchase_history: Object,
    },
    branding: Object,
    fetchPurchaseHistory: Function,
};

export class PurchaseHistory extends Component<Props> {
    componentDidMount() {
        this.props.fetchPurchaseHistory('active', 0, true);
    }

    render() {
        const { auth, branding } = this.props;

        return (
            <Fragment>
                <section id="ipx-maincontent" className="user-accounts">
                    <Form
                        purchaseHistory={auth.purchase_history}
                        fetchPurchaseHistory={this.props.fetchPurchaseHistory}
                        lng={auth.language}
                    />
                </section>
            </Fragment>
        );
    }
}

const mapStateToProps = (state: Object) => {
    return {
        auth: state.auth,
        branding: state.branding,
    };
};

export default connect(
    mapStateToProps,
    {
        fetchPurchaseHistory,
    }
)(PurchaseHistory);



// WEBPACK FOOTER //
// ./src/containers/Forms/PurchaseHistory.js